import api from './api';

async function GetChatsByAtendimentoId(atendimentoId) {
    if (!atendimentoId) {
        throw new Error('AtendimentoId é um parâmetro obrigatório');
    }
    var response = await api.get(`chat/atendimento/${atendimentoId}`);
    return response.data;
}

async function GetChatsByAtendimentoIdAndThreadIdWithPagination(atendimentoId, threadId, limit, offset) {
    if (!atendimentoId || !threadId) {
        throw new Error('AtendimentoId e ThreadId são parâmetros obrigatórios');
    }

    if (limit && typeof limit !== 'number') {
        throw new Error('O parâmetro limit deve ser um número');
    }
    if (offset && typeof offset !== 'number') {
        throw new Error('O parâmetro offset deve ser um número');
    }

    limit = limit || 10; // Define um valor padrão para limit se não for fornecido
    offset = offset || 0; // Define um valor padrão para offset se não for fornecido

    var response = await api.get(`chat/atendimento/${atendimentoId}/thread/${threadId}`, {
        params: {
            limit: limit,
            offset: offset,
        },
    });
    return response.data;
}

async function GetAllChatsByAtendimentoIdAndThreadId(atendimentoId, threadId) {
    if (!atendimentoId || !threadId) {
        throw new Error('AtendimentoId e ThreadId são parâmetros obrigatórios');
    }

    var response = await api.get(`chat/atendimento/${atendimentoId}/thread/${threadId}/all`);
    return response.data;
}

async function SendChat(atendimentoId, threadId, AssistenteId, mensagem) {
    if (!atendimentoId || !threadId || !mensagem) {
        throw new Error('AtendimentoId, ThreadId e Mensagem são parâmetros obrigatórios');
    }

    var response = await api.post(`chat/atendimento/${atendimentoId}/thread/${threadId}/send`, {
        Mensagem: mensagem,
        AssistenteId: AssistenteId,
    });
    return response.data;
}

export {
    GetChatsByAtendimentoId,
    GetChatsByAtendimentoIdAndThreadIdWithPagination,
    GetAllChatsByAtendimentoIdAndThreadId,
    SendChat,
};
